import { Tag } from 'components';
import React, { useContext } from 'react';
import {
  SubscriptionContainer,
  SubscriptionDetails,
  SubscriptionLogo,
  SubscriptionText,
  SubscriptionStatus,
} from '../styles';
import MLSUserPageContext from '../MLSUserPageContext';

type AnsweringServiceProps = {};

const AnsweringService: React.FC<AnsweringServiceProps> = () => {
  const {
    subscriptions: { answering },
  } = useContext(MLSUserPageContext);

  const { logo, name, status } = answering;
  return (
    <SubscriptionContainer>
      <SubscriptionDetails>
        <SubscriptionLogo src={logo} />
        <SubscriptionText>{name}</SubscriptionText>
        <SubscriptionStatus>
          <Tag color={status === 'Active' ? 'green' : 'gray'}>{status}</Tag>
        </SubscriptionStatus>
      </SubscriptionDetails>
    </SubscriptionContainer>
  );
};

export default AnsweringService;
